import * as api from "../constants/api";
import * as axiosUtils from "../utils/axiosUtils";

export const actionType = "FARGER";
const metaData = { entitet: "Farge", notify: true };

export function getFarger() {
  return axiosUtils.GetAll(api.GET_FARGER_URL, actionType);
}

export function postFarge(payload) {
  return axiosUtils.Post(api.POST_FARGE_URL, payload, actionType, metaData);
}

export function putFarge(payload) {
  return axiosUtils.Put(
    api.PUT_FARGE_URL(payload.id),
    payload,
    actionType,
    metaData,
  );
}
